<template>
  <div class="position-absolute v-header z-3">
    <div class="col-12">
      <div class="row">
        <div
          class="col-12 ps-4 pe-4 d-flex align-items-center justify-content-center v-theme-header"
        >
          <button @click="$router.go(-1)" class="btn-close-asset-rev"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailTopNav",
  props: ["heading", "subheading"],
  data() {
    return {
      componentName: this.heading === "renders" ? "AssetView" : "AssetType",
    };
  },
};
</script>
